module.exports = __webpack_public_path__ + "img/CS_new_icons_journey.134933e3.png";